const styles = {
  buttonIcon: {
    border: `none`,
    backgroundColor: `transparent`,
    outline: `none`
  },
  tableRow: { wordBreak: `break-word` }
};

export default styles;
